/**
 * Match media Hook
 *
 * @module    useMedia
 */
import {useState, useEffect} from 'react';

export default function useMedia({mediaQuery, defaultMatch = false}) {
  const [matches, setMatches] = useState(defaultMatch);
  const setMediaMatches = ({matches}) => {
    setMatches(matches);
  };

  useEffect(() => {
    if (!window.matchMedia) {
      return;
    }
    const mql = window.matchMedia(mediaQuery);
    setMatches(mql.matches);
    mql.addListener(setMediaMatches);
    return () => mql.removeListener(setMediaMatches);
  }, [mediaQuery]);
  return matches;
}
